/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VariableDto } from './VariableDto';
import {
    VariableDtoFromJSON,
    VariableDtoFromJSONTyped,
    VariableDtoToJSON,
    VariableDtoToJSONTyped,
} from './VariableDto';

/**
 * Valeur d'une variable dans le contexte d'un tunnel.
 * @export
 * @interface FunnelVariableDto
 */
export interface FunnelVariableDto {
    /**
     * 
     * @type {string}
     * @memberof FunnelVariableDto
     */
    id?: string;
    /**
     * 
     * @type {VariableDto}
     * @memberof FunnelVariableDto
     */
    variable?: VariableDto;
    /**
     * 
     * @type {string}
     * @memberof FunnelVariableDto
     */
    contextObjetId?: string;
    /**
     * 
     * @type {number}
     * @memberof FunnelVariableDto
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof FunnelVariableDto
     */
    typeContextVariable?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FunnelVariableDto
     */
    isUserConfigurable?: boolean;
    /**
     * Modifiable par le valideur des devis sur la page de validation.
     * @type {boolean}
     * @memberof FunnelVariableDto
     */
    isValideurConfigurable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FunnelVariableDto
     */
    possibleValues?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FunnelVariableDto
     */
    unite?: string | null;
}

/**
 * Check if a given object implements the FunnelVariableDto interface.
 */
export function instanceOfFunnelVariableDto(value: object): value is FunnelVariableDto {
    return true;
}

export function FunnelVariableDtoFromJSON(json: any): FunnelVariableDto {
    return FunnelVariableDtoFromJSONTyped(json, false);
}

export function FunnelVariableDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunnelVariableDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'variable': json['variable'] == null ? undefined : VariableDtoFromJSON(json['variable']),
        'contextObjetId': json['contextObjetId'] == null ? undefined : json['contextObjetId'],
        'value': json['value'] == null ? undefined : json['value'],
        'typeContextVariable': json['typeContextVariable'] == null ? undefined : json['typeContextVariable'],
        'isUserConfigurable': json['isUserConfigurable'] == null ? undefined : json['isUserConfigurable'],
        'isValideurConfigurable': json['isValideurConfigurable'] == null ? undefined : json['isValideurConfigurable'],
        'possibleValues': json['possibleValues'] == null ? undefined : json['possibleValues'],
        'unite': json['unite'] == null ? undefined : json['unite'],
    };
}

export function FunnelVariableDtoToJSON(json: any): FunnelVariableDto {
    return FunnelVariableDtoToJSONTyped(json, false);
}

export function FunnelVariableDtoToJSONTyped(value?: FunnelVariableDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'variable': VariableDtoToJSON(value['variable']),
        'contextObjetId': value['contextObjetId'],
        'value': value['value'],
        'typeContextVariable': value['typeContextVariable'],
        'isUserConfigurable': value['isUserConfigurable'],
        'isValideurConfigurable': value['isValideurConfigurable'],
        'possibleValues': value['possibleValues'],
        'unite': value['unite'],
    };
}

